import type { ListingStatus } from "@loot-os/fulfillment-core/listing/types";
import { Badge } from "@loot-os/ui/components/badge";
import { LISTING_STATUS_LABELS } from "../lib/listingStatus";

/** live = primary, test = secondary — consistent everywhere a key/user/open mode shows up. */
export function ModeBadge({ mode }: { mode: "live" | "test" }) {
  return <Badge variant={mode === "live" ? "default" : "secondary"}>{mode}</Badge>;
}

/** Box lifecycle: active = primary, draft and pre-release = secondary, archived = outline. */
export function StatusBadge({
  status,
}: {
  status: "active" | "draft" | "pre_release" | "archived";
}) {
  const variant = status === "active" ? "default" : status === "archived" ? "outline" : "secondary";
  const label = status === "pre_release" ? "pre-release" : status;
  return <Badge variant={variant}>{label}</Badge>;
}

/** Product-fetch lifecycle: COMPLETE = primary, PENDING/PARTIAL = secondary, FAILED = destructive. */
export function FetchStatusBadge({ status }: { status: string }) {
  const variant =
    status === "COMPLETE" ? "default" : status === "FAILED" ? "destructive" : "secondary";
  return <Badge variant={variant}>{status}</Badge>;
}

/** Vendor listing lifecycle: ACTIVE = primary, IMAGE_PROCESSING = secondary, INACTIVE = outline. */
export function ListingStatusBadge({ status }: { status: ListingStatus }) {
  const variant =
    status === "ACTIVE" ? "default" : status === "IMAGE_PROCESSING" ? "secondary" : "outline";
  return <Badge variant={variant}>{LISTING_STATUS_LABELS[status]}</Badge>;
}
